<div id="teacher-wallet-index" class="container margin-top-2">
  <h1 class="bold primary"><i class="fas fa-university"></i> {{ "you-wallet" | translate }}</h1>
  <mat-expansion-panel class="margin-top-2">
    <mat-expansion-panel-header class="black margin-top-2">
    <h2 class="bold primary">
      <i class="fas fa-piggy-bank"></i> {{ "movements" | translate }}
    </h2>
  </mat-expansion-panel-header>
    <div class="black">
      <a class="black" [ngClass]="{'active': filter_wallet==='todos'}" (click)="getWallet('todos')">TODOS</a>  |  
      <a class="black" [ngClass]="{'active': filter_wallet==='0'}" (click)="getWallet('0')">PENDIENTES</a>  |  
      <a class="black" [ngClass]="{'active': filter_wallet==='6'}" (click)="getWallet('6')">SOLICITADOS</a></div>
    <table mat-table [dataSource]="dataSource"> 

      <!--- Note that these columns can be defined in any order.
            The actual rendered columns are set as a property on the row definition" -->

      <!-- student Column -->
      <ng-container matColumnDef="student">
        <th mat-header-cell *matHeaderCellDef>{{ "student" | translate }}</th>
        <td mat-cell *matCellDef="let element">
          <div class="flex-start">
            <img
              [src]="element.studentImage"
              class="wallet-image"
              *ngIf="element.studentImage"
              appErrorImage
            />
            <div>
              {{ element.student }}
            </div>
          </div>
        </td>
      </ng-container>

      <!-- date Column -->
      <ng-container matColumnDef="date">
        <th mat-header-cell *matHeaderCellDef>{{ "date" | translate }}</th>
        <td mat-cell *matCellDef="let element">{{ element.date }}</td>
      </ng-container>

      <!-- status Column -->
      <ng-container matColumnDef="status">
        <th mat-header-cell *matHeaderCellDef>{{ "status" | translate }}</th>
        <td mat-cell *matCellDef="let element">
          {{ "wallet-status-teacher-" + element.state | translate }}
        </td>
      </ng-container>

      <!-- type Column -->
      <ng-container matColumnDef="type">
        <th mat-header-cell *matHeaderCellDef>
          <span>{{ "type" | translate }}</span>
        </th>
        <td mat-cell *matCellDef="let element">
          {{ "wallet-type-" + element.type_product | translate }}
        </td>
      </ng-container>

      <!-- amount Column -->
      <ng-container matColumnDef="amount">
        <th mat-header-cell *matHeaderCellDef>
          <span>{{ "amount" | translate }}</span>
        </th>
        <td mat-cell *matCellDef="let element">{{ element.amount | currency:"EUR" }}</td>
      </ng-container>

      <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
      <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
    </table>
    <mat-paginator
      [pageSize]="15"
      *ngIf="dataSource.length"
      [pageIndex]="paginate"
      (page)="onChangePage($event)"
      [length]="walletLength"
      (state)="filter_wallet"
    >
    </mat-paginator>
  </mat-expansion-panel>

  <!-- withdraw -->
  <div class="margin-top-2">
    <mat-card id="withdraw">
      <h2 class="primary bold">
        <i class="fas fa-user-tie"></i> {{ "withdraw" | translate }}
      </h2>
      <div class="row">
        <div class="col-md-6">
          <form [formGroup]="form" class="">
            <div class="pt-3">
              {{ "withdraw-paypal-text" | translate }}
            </div>
            <!-- Email -->
            <mat-form-field
              appearance="legacy"
              class="margin-top-1 margin-bottom-1"
            >
              <mat-label>{{ "email" | translate }}</mat-label>
              <input
                matInput
                class="form-control"
                formControlName="email"
                name="email"
                autocomplete="email"
              />
              <mat-error *ngIf="emailNoValido">
                {{ "valid-email" | translate }}
              </mat-error>
            </mat-form-field>
  
            <div class="large">
             <span class="bold">{{ "amount-to-withdraw" | translate }}:</span> <span class=""> {{ amountAvailable | currency:"EUR" }}</span>
            </div>
  
            <div class="row justify-content-center">
              <!-- Send Form -->
              <button
                mat-raised-button
                color="primary"
                class="width-50 margin-top-2 margin-bottom-1 padding-05 text-uppercase"
                type="submit"
                [disabled]="form.invalid || !amountAvailable"
                (click)="withdraw()"
              >
                <span>{{ "to-withdraw" | translate }}</span>
              </button>
            </div>
          </form>
        </div>
        <div class="col-md-6 p-3 border">
          <h3 class="bold primary pb-3"> {{ "withdraw-info-title" | translate }}</h3>
          <p><span [innerHTML]="'withdraw-funds-info-1' | translate"></span></p>
          
          <a href="https://www.paypal.com/es/home" target="_blank" class="btn btn-primary"><i class="fab fa-paypal"></i> {{ "go-to-paypal" | translate }}</a>
          <p class="pt-3"><span [innerHTML]="'withdraw-funds-info-2' | translate"></span></p>
        </div>
       
      </div>
    </mat-card>
  </div>
</div>
